import { render, staticRenderFns } from "./Rect.vue?vue&type=template&id=6a3c3dc1&scoped=true&"
import script from "./Rect.vue?vue&type=script&lang=js&"
export * from "./Rect.vue?vue&type=script&lang=js&"
import style0 from "./Rect.vue?vue&type=style&index=0&id=6a3c3dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3c3dc1",
  null
  
)

export default component.exports